/**
 * Axeptio Cookies Manager - Moon Moon Agency
 * Handles opening the Axeptio cookies consent popup via footer button
 */

/*********************************************************************************************
 * 🍪 AXEPTIO MANAGER
 */
const AxeptioManager = {
	config: {
		trigger: '[data-action="open-axeptio-cookies"]',
	},

	/**
	 * Initialize the Axeptio cookies manager
	 */
	init() {
		this._bindEvents();
		window.log('info', '🍪 [AXEPTIO]', 'Initialized');
	},

	_bindEvents() {
		document.addEventListener('click', (e) => {
			const trigger = e.target.closest(this.config.trigger);
			if (!trigger) return;

			e.preventDefault();
			this.openCookiesPopup(trigger);
		});
	},

	openCookiesPopup(trigger) {
		if (typeof openAxeptioCookies !== 'function') {
			window.log('warn', '🍪 [AXEPTIO]', 'openAxeptioCookies is not available');
			return;
		}

		try {
			openAxeptioCookies();
			window.log('info', '🍪 [AXEPTIO]', 'Cookies popup opened');
		} catch (error) {
			window.log('error', '🍪 [AXEPTIO]', 'Failed to open cookies popup', {
				error: error.message,
			});
		}
	},
};

// Auto-init
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => AxeptioManager.init());
} else {
	AxeptioManager.init();
}